import React from "react";

export const PrivacyTextFr = (props) => {
  return (
    <div id="privacy" className="text-center">
      <div className="containerInfo">
        <div className="section-title">
          <article className="arti">
            <h1 className="headerInfo">Politique de confidentialité</h1>
            <p>
              Les développeurs de ColorYou ont construit l'application ColorYou
              en tant qu'application Freemium. Ce SERVICE est fourni par
              ColorYou gratuitement et est destiné à être utilisé tel quel.
            </p>
            <p>
              Cette page est utilisée pour informer les visiteurs des politiques
              de collecte, d'utilisation et de divulgation des informations
              personnelles si quelqu'un décide d'utiliser le Service.
            </p>
            <p>
              Si vous choisissez d'utiliser le Service, vous acceptez la
              collecte et l'utilisation des informations conformément à cette
              politique. Les informations personnelles que nous collectons sont
              utilisées pour fournir et améliorer le Service. Nous n'utiliserons
              NI ne partagerons vos informations avec personne sauf tel que
              décrit dans cette Politique de confidentialité.
            </p>
            <p>
              Les termes utilisés dans cette Politique de confidentialité ont
              les mêmes significations que dans nos Conditions générales,
              accessibles sur ColorYou sauf indication contraire dans cette
              Politique de confidentialité.
            </p>
            <br />
            <p>
              <strong>
                Collecte et utilisation des informations (Photos et données
                faciales)
              </strong>
            </p>
            <div>
              <p>
                ColorYou vous permet de prendre ou de sélectionner une photo
                afin d’activer les essayages virtuels et l’analyse
                colorimétrique. Pour appliquer des superpositions de
                maquillage/coiffures et calculer votre palette saisonnière,
                l’app transmet votre photo
                <strong>via HTTPS</strong> à notre backend, où elle est traitée{" "}
                <strong>de manière transitoire en mémoire</strong> pour obtenir
                des <em>points de repère faciaux</em> (yeux, lèvres, contour du
                visage), des <em>masques de segmentation</em> et des
                <em>valeurs de couleur</em> (peau, cheveux, yeux). L’image et
                les données faciales dérivées{" "}
                <strong>ne sont pas enregistrées</strong>
                sur nos serveurs et sont supprimées immédiatement après le
                traitement.
              </p>

              <p>
                Nous <strong>ne</strong> créons ni ne collectons d’identifiants
                biométriques, d’empreintes/modèles faciaux, nous ne réalisons
                <strong>pas</strong> de reconnaissance faciale ni d’appariement
                d’identité, et nous n’accédons <strong>pas</strong> aux cartes
                de profondeur TrueDepth/Face ID.
              </p>

              <p>
                <strong>Comment nous utilisons les données faciales</strong>
              </p>
              <p>
                Uniquement pour : (i) afficher des essayages virtuels
                (maquillage, couleurs et coiffures) ; (ii) analyser votre
                palette saisonnière et les recommandations associées ; et (iii)
                prévisualiser des couleurs/motifs de vêtements et des
                combinaisons de style sur votre photo. Nous{" "}
                <strong>n’utilisons pas</strong> les données faciales à des fins
                de publicité, de pistage, d’authentification, d’appariement
                d’identité ou d’entraînement de modèles.
              </p>

              <p>
                <strong>Partage et divulgation</strong>
              </p>
              <p>
                Nous <strong>ne partageons pas</strong> vos photos ni vos
                données faciales avec des tiers. Les services utilisés pour les
                achats intégrés (p. ex., RevenueCat) ne reçoivent que des
                métadonnées de transaction/reçu — <strong>aucune</strong> image
                ni donnée faciale.
              </p>

              <p>
                <strong>Conservation et suppression</strong>
              </p>
              <p>
                Pour votre confort, la photo sélectionnée peut être enregistrée{" "}
                <strong>localement sur votre appareil</strong> afin d’éviter de
                la téléverser à nouveau. Vous pouvez supprimer toutes les
                données locales à tout moment depuis{" "}
                <em>Paramètres → Supprimer toutes vos données</em>, ou en
                désinstallant l’app. Le traitement côté serveur est éphémère ;
                nous <strong>ne conservons pas</strong> les images ni les
                données faciales après la réponse.
              </p>

              <p>
                <strong>Autres données</strong>
              </p>
              <p>
                Nous pouvons déterminer votre langue et déduire votre pays afin
                d’afficher du contenu localisé. Ces informations sont utilisées
                dans l’app et ne sont pas combinées avec les données faciales.
              </p>

              <p>
                <strong>Services tiers</strong>
              </p>
              <p>
                Liens vers les politiques de confidentialité des fournisseurs de
                services tiers utilisés par l’app :
              </p>
              <ul>
                <li>
                  <a
                    href="https://www.google.com/policies/privacy/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Google Play Services
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.revenuecat.com/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    RevenueCat
                  </a>
                </li>
              </ul>
            </div>

            <p>
              <strong>Données de journal</strong>
            </p>
            <p>
              Nous tenons à vous informer que chaque fois que vous utilisez mon
              Service, en cas d'erreur dans l'application, nous pouvons
              collecter des données et des informations (via des produits tiers)
              sur votre téléphone appelées Données de journal. Ces Données de
              journal peuvent inclure des informations telles que votre adresse
              IP, le nom de votre appareil, la version du système
              d'exploitation, la configuration de l'application lors de
              l'utilisation du Service, l'heure et la date de votre utilisation
              du Service et d'autres statistiques.
            </p>
            <p>
              <strong>Cookies</strong>
            </p>
            <p>
              Les cookies sont des fichiers contenant une petite quantité de
              données qui sont couramment utilisés comme identifiants uniques
              anonymes. Ils sont envoyés à votre navigateur à partir des sites
              Web que vous visitez et sont stockés dans la mémoire interne de
              votre appareil.
            </p>
            <p>
              Ce Service n'utilise PAS explicitement ces "cookies". Cependant,
              l'application peut utiliser du code et des bibliothèques tiers qui
              utilisent des "cookies" pour collecter des informations et
              améliorer leurs services. Vous avez la possibilité d'accepter ou
              de refuser ces cookies et de savoir quand un cookie est envoyé à
              votre appareil. Si vous choisissez de refuser nos cookies, vous
              pourriez ne pas être en mesure d'utiliser certaines parties de ce
              Service.
            </p>
            <p>
              <strong>Prestataires de services</strong>
            </p>
            <p>
              Nous pouvons employer des sociétés tierces et des individus pour
              les raisons suivantes:
            </p>
            <ul>
              <li>Pour faciliter notre Service ;</li>
              <li>Pour fournir le Service en notre nom ;</li>
              <li>Pour effectuer des services liés au Service ; ou</li>
              <li>
                Pour nous aider à analyser comment notre Service est utilisé.
              </li>
            </ul>
            <p>
              Nous tenons à informer les utilisateurs de ce Service que ces
              tiers ont accès à leurs informations personnelles. La raison en
              est d'effectuer les tâches qui leur sont assignées en notre nom.
              Cependant, ils sont tenus de ne pas divulguer ou utiliser les
              informations à d'autres fins.
            </p>
            <p>
              <strong>Sécurité</strong>
            </p>
            <p>
              Nous attachons de l'importance à votre confiance en nous
              fournissant vos informations personnelles, c'est pourquoi nous
              nous efforçons d'utiliser des moyens commercialement acceptables
              pour les protéger. Mais rappelez-vous qu'aucune méthode de
              transmission sur Internet, ni méthode de stockage électronique
              n'est sécurisée à 100 % et fiable, et nous ne pouvons garantir sa
              sécurité absolue.
            </p>
            <p>
              <strong>Liens vers d'autres sites</strong>
            </p>
            <p>
              Ce Service peut contenir des liens vers d'autres sites. Si vous
              cliquez sur un lien tiers, vous serez dirigé vers ce site. Notez
              que ces sites externes ne sont pas exploités par nous. Par
              conséquent, nous vous conseillons vivement de consulter la
              Politique de confidentialité de ces sites Web. Nous n'avons aucun
              contrôle sur le contenu, les politiques de confidentialité ou les
              pratiques des sites ou services tiers.
            </p>
            <p>
              <strong>Confidentialité des enfants</strong>
            </p>
            <div>
              <p>
                Ces Services ne s'adressent à personne de moins de 13 ans. Nous
                ne collectons pas sciemment d'informations personnelles
                identifiables auprès d'enfants de moins de 13 ans. Dans le cas
                où nous découvririons qu'un enfant de moins de 13 ans nous a
                fourni des informations personnelles, nous supprimerions
                immédiatement ces informations de nos serveurs. Si vous êtes un
                parent ou un tuteur et que vous savez que votre enfant nous a
                fourni des informations personnelles, veuillez me contacter afin
                que je puisse prendre les mesures nécessaires.
              </p>
              <p>
                <strong>
                  Modifications de cette politique de confidentialité
                </strong>
              </p>
              <p>
                Nous pouvons mettre à jour notre Politique de confidentialité de
                temps à autre. Ainsi, nous vous conseillons de consulter cette
                page périodiquement pour toute modification. Nous vous
                informerons de toute modification en publiant la nouvelle
                Politique de confidentialité sur cette page.
              </p>
              <p>Cette politique est en vigueur à partir du 2024-03-01</p>
              <p>
                <strong>Nous contacter</strong>
              </p>
              <p>
                Si vous avez des questions ou des suggestions concernant notre
                Politique de confidentialité, n'hésitez pas à nous contacter à
                l'adresse{" "}
                <span style={{ color: "#DD3D99" }}> coloryouapp@gmail.com</span>
                .
              </p>
            </div>
          </article>
        </div>
      </div>
    </div>
  );
};
